export default "__VITE_ASSET__1fcdb708__"